import axios from 'axios';
import applicationSettings from '../Core/Settings/ApplicationSettings';
import {
    DemeterAnalyticsApi,
    DemeterApi,
    DemeterArtificialIntelligenceApi,
    DemeterCalculatorsApi,
    DemeterChartsApi,
    DemeterCompaniesApi,
    DemeterDashboardsApi,
    DemeterDomesticsApi,
    DemeterDownloadsApi,
    DemeterEmailSubscriptionsApi,
    DemeterExportsApi,
    DemeterImportsApi,
    DemeterMarketIndicatorsApi,
    DemeterNewsApi,
    DemeterOtherApi,
    DemeterPageElementsApi,
    DemeterPositionsApi,
    DemeterPresentationTemplatesApi,
    DemeterProductionApi,
    DemeterRegistrationApi,
    DemeterStocksApi,
    DemeterUserDataApi,
    DemeterUsersApi,
    DemeterWorkerSyncStatusesApi,
} from '../Generated/Raven-Demeter/api';
import { Configuration } from '../Generated/Raven-Demeter/configuration';
import { FuturesApi, MarketIntelligenceApi, UsersApi } from '../Generated/Raven/api';

export type ApiError = Error & { response: { data?: { errors: string[]; detail: string }; status: number } };

const demeterAnalyticsApi = new DemeterAnalyticsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterApi = new DemeterApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterArtificialIntelligenceApi = new DemeterArtificialIntelligenceApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterCalculatorsApi = new DemeterCalculatorsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterChartsApi = new DemeterChartsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterCompanyApi = new DemeterCompaniesApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterDashboardsApi = new DemeterDashboardsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterDomesticsApi = new DemeterDomesticsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterDownloadsApi = new DemeterDownloadsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterExportsApi = new DemeterExportsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterImportsApi = new DemeterImportsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterMarketIndicatorsApi = new DemeterMarketIndicatorsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterNewsApi = new DemeterNewsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterOtherApi = new DemeterOtherApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterPositionsApi = new DemeterPositionsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterPageElementsApi = new DemeterPageElementsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterPresentationTemplatesApi = new DemeterPresentationTemplatesApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterProductionApi = new DemeterProductionApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterStocksApi = new DemeterStocksApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterRegistrationApi = new DemeterRegistrationApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterUserDataApi = new DemeterUserDataApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterUsersApi = new DemeterUsersApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterEmailSubscriptionsApi = new DemeterEmailSubscriptionsApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const demeterWorkerSyncStatusesApi = new DemeterWorkerSyncStatusesApi(new Configuration(), applicationSettings.api?.ravenBackendDemterUri, axios);
const futuresApi = new FuturesApi(new Configuration(), applicationSettings.api?.ravenBackendUri, axios);
const marketIntelligenceApi = new MarketIntelligenceApi(new Configuration(), applicationSettings.api?.ravenBackendUri, axios);
const usersApi = new UsersApi(new Configuration(), applicationSettings.api?.ravenBackendUri, axios);

export {
    demeterAnalyticsApi,
    demeterApi,
    demeterArtificialIntelligenceApi,
    demeterCalculatorsApi,
    demeterChartsApi,
    demeterCompanyApi,
    demeterDashboardsApi,
    demeterDomesticsApi,
    demeterDownloadsApi,
    demeterPositionsApi,
    demeterPresentationTemplatesApi,
    demeterProductionApi,
    demeterStocksApi,
    demeterImportsApi,
    demeterExportsApi,
    demeterMarketIndicatorsApi,
    demeterNewsApi,
    demeterOtherApi,
    demeterPageElementsApi,
    demeterRegistrationApi,
    demeterUserDataApi,
    demeterUsersApi,
    demeterEmailSubscriptionsApi,
    demeterWorkerSyncStatusesApi,
    futuresApi,
    marketIntelligenceApi,
    usersApi,
};
